const isContentExist = (element: Element) => {
  for (const node of element.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
      return true
    }
  }
  for (const child of element.children) {
    if (isContentExist(child)) {
      return true
    }
  }
  return false
}

const unwrapAllNestedDetails = (parentNode: ParentNode) => {
  const details = parentNode.querySelectorAll('details')
  details.forEach((outerDetails) => {
    const children = Array.from(outerDetails.children).filter(
      (el) => el.nodeType === Node.ELEMENT_NODE
    )

    const isContentExist = Array.from(outerDetails.childNodes).some(
      (node) => node.nodeType === Node.TEXT_NODE && (node as Text).textContent?.trim() !== ''
    )

    const isEveryChildDetails = children.every((child) => child.tagName === 'DETAILS')

    if (isEveryChildDetails && !isContentExist) {
      const fragment = document.createDocumentFragment()

      children.forEach((innerDetails) => {
        fragment.appendChild(innerDetails)
      })

      outerDetails.replaceWith(fragment)
      unwrapAllNestedDetails(fragment)
    }
  })
}

export const prepareDetailsElements = (htmlValue: Document) => {
  const details = htmlValue.querySelectorAll('details')

  //Remove all empty details without text
  details.forEach((detailNode: Element) => {
    if (!isContentExist(detailNode)) {
      detailNode.remove()
    }
  })

  //Remove details as wrapper, if all children is details
  unwrapAllNestedDetails(htmlValue)
}
